var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27262 26.5C9.77469 26.5 10.1817 26.0949 10.1817 25.5953C10.1817 25.0956 9.77469 24.6905 9.27262 24.6905C8.77054 24.6905 8.36353 25.0956 8.36353 25.5953C8.36353 26.0949 8.77054 26.5 9.27262 26.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2726 26.5C19.7747 26.5 20.1817 26.0949 20.1817 25.5953C20.1817 25.0956 19.7747 24.6905 19.2726 24.6905C18.7705 24.6905 18.3635 25.0956 18.3635 25.5953C18.3635 26.0949 18.7705 26.5 19.2726 26.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.5H5.63636L8.07273 19.6148C8.15586 20.0313 8.38355 20.4055 8.71595 20.6718C9.04835 20.9381 9.46427 21.0796 9.89091 21.0714H18.7273C19.1539 21.0796 19.5698 20.9381 19.9022 20.6718C20.2346 20.4055 20.4623 20.0313 20.5455 19.6148L22 12.0238H6.54545",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8.5,
    r: 7,
    fill: "#E5D062",
    stroke: "#14141B",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.8458337aac423065dfeafdf29c70c364.svg";
export { ForwardRef as ReactComponent };